import { generateUtilityClass, generateUtilityClasses } from '@mui/base';
export function getTooltipUtilityClass(slot) {
  return generateUtilityClass('MuiTooltip', slot);
}
const tooltipClasses = generateUtilityClasses('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
export default tooltipClasses;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/Tooltip/tooltipClasses.js
// module id = 359
// module chunks = 1